<template>
  <div v-if="show" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
    <div class="bg-card rounded-lg w-full max-w-md md:max-w-lg p-6 shadow-lg relative">
      <button @click="$emit('cancel')" aria-label="Close modal" class="absolute top-3 right-3 text-muted-foreground hover:text-foreground text-xl focus:outline-none">
        <i class="fas fa-times"></i>
      </button>
      <h3 class="text-xl md:text-2xl font-semibold text-foreground mb-3 text-center">Login or Register Required</h3>
      <p class="text-muted-foreground mb-6 text-center">
        You need to be logged in to use this feature. Please login or register to continue.
      </p>
      <div class="flex flex-col md:flex-row justify-center gap-3 mt-4">
        <button @click="$emit('login')" class="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-primary hover:bg-primary-dark text-primary-foreground rounded-lg transition text-base font-medium">
          <i class="fas fa-sign-in-alt"></i> Login
        </button>
        <button @click="$emit('register')" class="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-secondary hover:bg-secondary-dark text-white rounded-lg transition text-base font-medium">
          <i class="fas fa-user-plus"></i> Register
        </button>
        <button @click="$emit('cancel')" class="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-muted hover:bg-accent text-foreground rounded-lg transition text-base font-medium">
          <i class="fas fa-times-circle"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean
  }
}
</script>

<style scoped>
.bg-secondary {
  background-color: #6366f1;
}
.bg-secondary-dark {
  background-color: #4f46e5;
}
@media (max-width: 640px) {
  .max-w-md {
    max-width: 95vw !important;
  }
}
</style> 